import React from 'react';

const supportItems = [
  'Anxiety',
  'Depression',
  'Grief',
  'Trauma',
  'Life transitions',
  'Emotional wellness',
];

const ChallengesSection = () => (
  <section id="challenges" className="relative" style={{ backgroundColor: 'var(--cream-canvas)' }}>
    <div className="container mx-auto px-4 sm:px-6 lg:px-8" style={{ maxWidth: '1280px' }}>
      <div
        className="rounded-full border px-5 py-4 sm:px-6 sm:py-5"
        style={{
          marginTop: '-70px',
          backgroundColor: 'var(--surface-card)',
          borderColor: 'rgba(31, 42, 36, 0.08)',
          boxShadow: '0 14px 32px rgba(20, 48, 36, 0.12)',
        }}
      >
        <div className="flex flex-wrap items-center gap-2 sm:gap-3">
          <span className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>
            Support for:
          </span>
          {supportItems.map((item) => (
            <span
              key={item}
              className="rounded-full px-3 py-1.5 text-xs sm:text-sm"
              style={{ backgroundColor: 'var(--surface-soft-1)', color: 'var(--text-muted)' }}
            >
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default ChallengesSection;
